import { autocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";

import { css } from "styled-components";

autocompleteProductsStyles.titleLink = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 0;
        `,
    },
    css: css`
        width: 100%;
    `,
};
